import { EnglishArabicDTO } from "bnsights-control-library"
export class LookUpItem
{
      ID:number
      UpdatedID:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Manageable :boolean
      DisplayOrder?:number
      IDEncrypted :string
      Value :string
      LookupID?:number
      LookupName :EnglishArabicDTO=new EnglishArabicDTO();
      SysName :string
      IsParentLookupManageable:boolean
      }
     